// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__367u2","filesListContainer":"PosDisputesFiles_filesListContainer__1kcEp","filesButton":"PosDisputesFiles_filesButton__3HTHo"};